import { Navigate, createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { tripsFiltersSchema } from "@/features/trips/schemas/trips-filters.schema";

export const Route = createFileRoute("/_authenticated/driver/")({
	component: () => {
		return <Navigate to="/driver/my-trips" />;
	},
	validateSearch: zodValidator(tripsFiltersSchema),
});
